
namespace RioERP.Products {

    @Serenity.Decorators.registerClass()
    export class ProductSpecificationsGrid extends Serenity.EntityGrid<ProductSpecificationsRow, any> {
        protected getColumnsKey() { return ProductSpecificationsColumns.columnsKey; }
        protected getDialogType() { return ProductSpecificationsDialog; }
        protected getIdProperty() { return ProductSpecificationsRow.idProperty; }
        protected getInsertPermission() { return ProductSpecificationsRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductSpecificationsRow.localTextPrefix; }
        protected getService() { return ProductSpecificationsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}